import { createFileRoute, redirect } from "@tanstack/react-router";
import {
  MIYAGI_RESIDENCE_CARD_CAMPAIGN_END_DATE,
  MIYAGI_RESIDENCE_CARD_CAMPAIGN_START_DATE,
} from "../../../config";
import { getCurrentTime } from "../../../libs/date";
import { t } from "../../../libs/i18n";
import {
  getResidenceCardExpiresAt,
  openResidenceCardRegistration,
  requestResidenceCardPermissions,
} from "../../../libs/sdk";

const backHomeWithError = (message: string) =>
  redirect({
    to: "/",
    state: { toast: { message, type: "error" } },
  });

// ようこそみやぎ外国人ポイントの受け取りフロー。
// みやぎ防災の登録（bousai.callback）から遷移し、
// 在留カード情報取得への同意とカード読み取りを済ませて付与に進む
export const Route = createFileRoute("/_authed/residence-card/apply")({
  loader: async ({ context: { tenant, client } }) => {
    if (tenant.slug !== "miyagi") {
      return backHomeWithError(t("キャンペーンが見つかりません"));
    }

    // 同意やカード読み取りを始める前に落とす。URL 直叩きでも
    // 一連の操作をさせた末にバックエンドで拒否される形にはしない
    const campaignStatuses = await client.getMyCampaignStatuses({});
    if (campaignStatuses.r8MiyagiResidenceCard?.isApplied) {
      return backHomeWithError(t("すでにポイントを受け取り済みです"));
    }

    const currentTime = await getCurrentTime();
    if (
      currentTime.source !== "client" &&
      (currentTime.date < MIYAGI_RESIDENCE_CARD_CAMPAIGN_START_DATE ||
        currentTime.date > MIYAGI_RESIDENCE_CARD_CAMPAIGN_END_DATE)
    ) {
      return backHomeWithError(t("キャンペーン期間外です"));
    }

    // 特定在留カード等の情報を取得することへの同意
    const permission = await requestResidenceCardPermissions();
    if (permission === "cancel") {
      return backHomeWithError(
        t("同意が確認できなかったため、ポイントの受け取りを中断しました"),
      );
    }

    // 暗証番号・在留カード等番号の入力とカード読み取り
    const registration = await openResidenceCardRegistration();
    if (registration === "cancel") {
      return backHomeWithError(
        t(
          "カードの読み取りがキャンセルされたため、ポイントの受け取りを中断しました",
        ),
      );
    }

    // 受け取り可否はバックエンドが最終判定するが、期限切れは想定内の状態なので
    // ここで判定してエラー画面ではなく理由をトーストで返す
    const expiresAt = await getResidenceCardExpiresAt();
    if (!expiresAt) {
      return backHomeWithError(t("特定在留カード等の読み取りに失敗しました"));
    }

    // 端末の時計は信用しない。サーバー時刻が取れないときはバックエンドの判定に委ねる
    if (currentTime.source !== "client" && currentTime.date >= expiresAt) {
      return backHomeWithError(
        t(
          "特定在留カード等の有効期限が切れているため、ポイントを受け取れません",
        ),
      );
    }

    return redirect({
      to: "/lottery/grant/processing",
      search: { campaign: "r8MiyagiResidenceCard" },
    });
  },
});
